.topMenuRow {
  border-bottom: 1px solid var(--colors-grays-light);
  padding-bottom: 24px;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 8px;
}

.menuRowLabel {
  color: var(--colors-text-main);
  margin-bottom: auto;
  margin-top: auto;
}

.viewAll {
  margin-left: 24px;
}

@media all and (--reefer-media-tablet-min) {
  .topMenuRow {
    padding-bottom: 32px;
    padding-left: 0px;
    padding-right: 0px;
  }
}
